import React from "react";
import "./Hero.css";
import { useLanguage } from "../context/LanguageContext";

const Hero = () => {
  const { t } = useLanguage();

  return (
    <section className="hero" id="home">
      <div className="hero-container">
        {/* Left Content */}
        <div className="hero-content">
          <div className="hero-badge">
            {t("✦ Professional Portrait Artist ✦", "✦ فنان بورتريه محترف ✦")}
          </div>

          <h1 className="hero-title">
            <span className="title-line">{t("Bringing Moments", "لحظات")}</span>
            <span className="title-line accent">{t("to Life", "للحياة")}</span>
            <span className="title-line">
              {t("in Graphite", "بالقلم الرصاص")}
            </span>
          </h1>

          <p className="hero-description">
            {t(
              "Hand-drawn pencil portraits that capture the soul, personality, and emotion of your most precious moments. Each stroke tells a story.",
              "بورتريهات مرسومة بالقلم الرصاص تعكس الروح والشخصية والمشاعر من أجمل لحظاتك. كل خط يحكي قصة.",
            )}
          </p>

          <div className="hero-buttons">
            <a href="#gallery" className="btn-hero-primary">
              <span>🎨</span>
              {t("View Gallery", "عرض المعرض")}
            </a>
            <a href="#order" className="btn-hero-secondary">
              <span>✏️</span>
              {t("Commission Portrait", "اطلب بورتريه")}
            </a>
            <a
              href="https://www.youtube.com/@ShadiArts"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-hero-youtube"
            >
              <span>▶️</span>
              {t("Watch on YouTube", "شاهد على يوتيوب")}
            </a>
           
            <a
              href="https://www.tiktok.com/@shadi.arts"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-link tiktok-link"
            >
              <span>🎵</span>
              {t("TikTok", "تيك توك")}
            </a>
         
            <a
              href="https://www.facebook.com/profile.php?id=61591635568693"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-link tiktok-link"
            >
              <span>📘</span>
              {t("Facebook", "فيس بوك")}
            </a>
             
            <a
              href="https://www.instagram.com/shadiarts.art"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-link tiktok-link"
            >
              <span>📸</span>
              {t("Instagram", "انستجرام")}
            </a>
              
          </div>

          <div className="hero-stats">
            <div className="stat-item">
              <span className="stat-number">50+</span>
              <span className="stat-label">
                {t("Portraits Created", "بورتريه منجز")}
              </span>
            </div>
            <div className="stat-item">
              <span className="stat-number">2+</span>
              <span className="stat-label">
                {t("Years Experience", "سنوات خبرة")}
              </span>
            </div>
            <div className="stat-item">
              <span className="stat-number">100%</span>
              <span className="stat-label">
                {t("Satisfaction", "رضا العملاء")}
              </span>
            </div>
          </div>
        </div>

        {/* Right Content - Artist Profile Card */}
        <div className="hero-right">
          <div className="profile-card">
            <div className="profile-image-wrapper">
              <img
                src="/assets/shadi-profile.jpg"
                alt="Shadi - Portrait Artist"
                className="profile-image"
                onError={(e) => {
                  e.target.style.display = "none";
                  e.target.parentElement.style.background =
                    "linear-gradient(135deg, var(--gold-primary), var(--gold-secondary))";
                  e.target.parentElement.innerHTML =
                    '<span class="profile-fallback">🎨</span>';
                }}
              />
            </div>

            <h2 className="profile-name">{t("Shadi", "شادي")}</h2>
            <p className="profile-title">
              {t("Pencil Portrait Artist", "فنان بورتريه بالقلم الرصاص")}
            </p>

            <p className="profile-bio">
              {t(
                "Classical musician turned self-taught artist. I bring faces to life with the delicate dance of graphite on paper.",
                "موسيقي كلاسيكي تحول إلى فنان علم نفسه بنفسه. أحول الوجوه إلى حياة من خلال رقص القلم الرصاص على الورق.",
              )}
            </p>

            <div className="profile-contact">
              <a
                href="mailto:shadiarts.official@gmail.com"
                className="contact-link"
              >
                <span>📧</span>
                shadiarts.official@gmail.com
              </a>
              <a
                href="https://wa.me/201151638804"
                className="contact-link whatsapp-number"
              >
                <span>💬</span>
                <span className="phone-number">+20 115 163 8804</span>
              </a>
            </div>

            <div className="profile-credentials">
              <span className="credential">
                {t("💎 100% Hand-Drawn", "💎 مرسوم يدوياً 100%")}
              </span>
              <span className="credential">
                {t("🎓 Self-Taught", "🎓 علم نفسه بنفسه")}
              </span>
              <span className="credential">
                {t("🎵 Classical Musician", "🎵 موسيقي كلاسيكي")}
              </span>
            </div>
          </div>

          {/* YouTube Banner */}
          <div className="youtube-banner">
            <div className="youtube-banner-content">
              <div className="youtube-icon">▶️</div>
              <div className="youtube-text">
                <h4>
                  {t(
                    "Subscribe to Official Channel",
                    "اشترك في القناة الرسمية",
                  )}
                </h4>
                <p>
                  {t(
                    "Watch time-lapse videos and creative process",
                    "شاهد فيديوهات التصوير المتسارع والعملية الإبداعية",
                  )}
                </p>
              </div>
            </div>
            <a
              href="https://www.youtube.com/@ShadiArts"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-youtube-small"
            >
              {t("Subscribe", "اشترك")}
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="scroll-indicator">
        <div className="mouse">
          <div className="wheel"></div>
        </div>
        <span className="scroll-text">
          {t("Scroll to explore", "تمرير لاستكشاف")}
        </span>
      </div>
    </section>
  );
};

export default Hero;
